import { Tooltip, TooltipPlacement } from 'farmhub-ui-core';

import { NameText } from 'components';
import { ArrowLeftIcon } from 'components/Icon';

import { IconWrapper, WrapperBack } from './styles';

interface BackMenuProps {
  isToggle: boolean;
  onClick: (e: any) => void;
}

const BackMenu = ({ isToggle, onClick }: BackMenuProps): JSX.Element => (
  <Tooltip placement={TooltipPlacement.Right} title={!isToggle && 'Quay lại'}>
    <WrapperBack isToggle={isToggle} onClick={onClick}>
      <IconWrapper>
        <ArrowLeftIcon height={12} width={12} />
      </IconWrapper>

      {isToggle && (
        <NameText className="text" style={{ marginLeft: 10 }} weight="medium">
          Quay lại danh mục
        </NameText>
      )}
    </WrapperBack>
  </Tooltip>
);

export default BackMenu;
